export default function(theme) {
  return {

    card: {
      display: 'inline-block',
      width: theme.spacing.unit * 55,
      marginTop: '10vh'
    }

  }
}



// WEBPACK FOOTER //
// ./src/styles/components/NoKeys.js